/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

class CarouselComponent extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(".carousel-track");
    this.handleControls();
    this.handleControlsPosition();
    this.handlePagination();
  }

  handleControls() {
    const firstSlideOffset = this.querySelector(".carousel-slide:nth-child(1)").getBoundingClientRect().left;
    const secondSlideOffset = this.querySelector(".carousel-slide:nth-child(2)").getBoundingClientRect().left;
    const slideWidth = secondSlideOffset - firstSlideOffset;

    this.querySelectorAll(".carousel-control").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.name === "previous") {
          if (this.track.scrollLeft <= 16) {
            this.track.scrollTo({ left: this.track.scrollWidth, behavior: "smooth" });
          } else {
            this.track.scrollBy({ left: -slideWidth, behavior: "smooth" });
          }
        } else {
          if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 16) {
            this.track.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            this.track.scrollBy({ left: slideWidth, behavior: "smooth" });
          }
        }
      });
    });
  }

  handleControlsPosition() {
    if (this.dataset.controlsAdaptToImage !== "true") return;

    const update = () => {
      const image = this.querySelector(".carousel-slide img") || this.querySelector(".carousel-slide .placeholder-svg");
      if (!image) return;
      const offset = image.clientHeight / 2;
      this.querySelectorAll(".carousel-control").forEach((btn) => {
        btn.style.top = `${offset}px`;
      });
    };
    update();

    window.addEventListener("resize", this.throttle(update, 150));
  }

  handlePagination() {
    const pagination = this.querySelector(".carousel-pagination");
    if (!pagination) return;

    const totalSlides = this.querySelectorAll(".carousel-slide").length;

    const update = () => {
      const visibleSlides = Math.floor(this.track.clientWidth / this.querySelector(".carousel-slide").clientWidth);
      const firstVisibleSlide = Math.round(this.track.scrollLeft / this.querySelector(".carousel-slide").clientWidth) + visibleSlides;

      pagination.querySelector("span").innerHTML = `${firstVisibleSlide}/${totalSlides}`;
    };
    update();

    this.track.addEventListener("scroll", () => {
      this.throttle(update(), 150);
      this.debounce(update(), 50);
    });
    window.addEventListener("resize", this.throttle(update, 150));
  }

  throttle(func, limit) {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  }

  debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }
}
customElements.define("carousel-component", CarouselComponent);
